import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentComponent, ApContentPipe } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApModalComponent } from '@ap/modal';

import { BrowserOutdatedModalComponent } from './browser-outdated-modal.component';

/**
 * @ngdoc module
 * @name BrowserOutdatedModalModule
 **/
@NgModule({
    declarations: [BrowserOutdatedModalComponent],
    imports: [ApButtonComponent, ApContentPipe, ApContentComponent, ApIllustrationComponent, ApModalComponent, CommonModule]
})
export class BrowserOutdatedModalModule {}
